import React from "react";
import Helmet from "react-helmet";

import { FormControl, InputLabel, OutlinedInput, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import Botao from "./botao/botao";

import isDC from "./isDC"

import './App.scss'

const styles = theme => ({
  root: {
    "&$focused $notchedOutline": {
      borderColor: isDC ? '#3f51b5' : '#009739',
      color: isDC ? '#3f51b5' : '#009739',
    }
  },
  focused: {},
  notchedOutline: {}
});

function adjustingInterval(workFunc, interval, errorFunc) {
  var that = this;
  var expected, timeout;
  this.interval = interval;

  this.start = function () {
    expected = Date.now() + this.interval;
    timeout = setTimeout(step, this.interval);
  }

  this.stop = function () {
    clearTimeout(timeout);
  }

  function step() {
    var drift = Date.now() - expected;
    if (drift > that.interval) {
      // You could have some default stuff here too...
      if (errorFunc) errorFunc();
    }
    workFunc();
    expected += that.interval;
    timeout = setTimeout(step, Math.max(0, that.interval - drift));
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Tracksale: null,
      name: '',
      email: '',
      submited: false,
      erros: [],
      verifications: 0,
      isVerifying: false,
      finished: false
    };

    this.url = new URL(window.location.href);
    this.origin = this.url.searchParams.get('o');
    this.classesPP = this.origin

    this.handleScriptInject = this.handleScriptInject.bind(this);
    this.verifyWidget = this.verifyWidget.bind(this);
  }

  handleScriptInject({ scriptTags }) {
    if (scriptTags) {
      const scriptTag = scriptTags[0];
      scriptTag.onload = () => {
        // I don't really like referencing window.
        console.log(`Tracksale loaded!`, window.Tracksale);
        this.setState({
          Tracksale: window.Tracksale
        });
      };
    }
  }

  initTracksale = () => {
    const rand = () => Math.random(0).toString(36).substr(2);
    const token = (length) => (rand() + rand() + rand() + rand()).substr(0, length);


    const key = this.origin == 'dc' ? 'b57cbc42e31f546b' : '0bc6b46dd9fecd90'
    const campaign = this.origin == 'dc' ? '39b98f9c' : 'f324c397'

    var config = {
      key: key,
      campaign: campaign,
      identification: token(40),
      name: this.state.name,
      email: this.state.email,
      salute: "%name.first%, tudo bem?",
      thanks: "Obrigado, %name.first%!",
      appendTo: "id-elemento-html"
    }
    new this.state.Tracksale().init(config)
  }

  formSubmit = () => {
    this.setState({ submited: true })
    this.initTracksale()
  }

  getWidget() {
    return (
      <div className="form-container">
        <div className="container-title">
          <h1 className={`title ${this.classesPP}`}>PESQUISA DE SATISFAÇÃO</h1>

          <span className="subtitle">Sua opinião é muito importante para nós!</span><br />
          <span className="subtitle">Por favor, insira seus dados:</span>
        </div>

        <FormControl error={this.state.erros['name']}>
          <InputLabel className={`label-name ${this.classesPP}`} htmlFor="name-input">Nome:</InputLabel>
          <OutlinedInput
            label={"Nome:"}
            value={this.state.name}
            name="name"
            id="name-input"
            classes={this.props.classes}
            error={this.state.erros['name']}
            onChange={(e) => this.setState({ name: e.target.value })}
            required={true}
          />
        </FormControl>

        <FormControl error={this.state.erros['email']}>
          <InputLabel className={`label-email ${this.classesPP}`} htmlFor="email-input">Email:</InputLabel>
          <OutlinedInput
            label={"Email:"}
            value={this.state.email}
            name="email"
            id="email-input"
            onChange={(e) => this.setState({ email: e.target.value })}
            classes={this.props.classes}
            error={this.state.erros['email']}
            required={true}
          />
        </FormControl>

        {!this.state.submited && <Botao classes={`botao-prosseguir ${this.classesPP}`} tipo="secundario"
          onClick={this.formSubmit}>Prosseguir</Botao>}

        {this.state.finished && (
          <div className="finished">
            <span className="subtitle">Caro cliente, notamos que você respondeu a pesquisa recentemente. Obrigado!</span>
          </div>
        )}
      </div>
    )
  }

  async sleep(msec) {
    return new Promise(resolve => setTimeout(resolve, msec));
  }

  test = async () => {
    var verifications = 3;
    for (var i = 1; i <= verifications; i++) {
      await this.sleep(1000)
      console.log('verificando...')
      const widget = document.getElementById('tracksale-wrapper');
      if (!widget && i == verifications) {
        this.setState({ finished: true })
      }
    }
  }

  verifyWidget() {
    if (!this.state.isVerifying) {
      // const doWork = (ticker) => {
      //   if (this.state.verifications >= 3) {
      //     ticker.stop()
      //   }
      //   console.log('verificando...')

      //   this.setState({ verifications: this.state.verifications + 1 })
      // };

      // // Define what to do if something goes wrong
      // const doError = () => {
      //   console.warn('The drift exceeded the interval.');
      // };

      // // (The third argument is optional)
      // var ticker = new adjustingInterval(() => doWork(ticker), 1000, doError);

      // ticker.start();
      this.test()
      this.setState({ isVerifying: true })
    }
  }

  render() {
    return (
      <div>
        <Helmet
          script={[{ src: "https://cdn.tracksale.co/tracksale-js/tracksale.js" }]}
          // Helmet doesn't support `onload` in script objects so we have to hack in our own
          onChangeClientState={(newState, addedTags) => this.handleScriptInject(addedTags)}
        />
        {this.state.Tracksale !== null ? this.getWidget() : "Tracksale is loading..."}
        {this.state.submited && this.verifyWidget()}
      </div>
    );
  }
}

export default withStyles(styles)(App);